import { render, staticRenderFns } from "./LessonFeeForm.vue?vue&type=template&id=623f1ec1&scoped=true&"
import script from "./LessonFeeForm.vue?vue&type=script&lang=js&"
export * from "./LessonFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f1ec1",
  null
  
)

export default component.exports